import { SheetPageBody, SheetPageTitle } from "@/components/ui/sheet-page"
import {
  AlertCircle,
  Check,
  CheckCircle2,
  Mail,
  X,
  XCircle,
} from "lucide-react"
import { useNewProps } from "./page-props"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { Alert, AlertDescription } from "@/components/ui/alert"
import { Link } from "@/lib/page-rendering"

export default function Page() {
  const { t } = useTranslation("invitations")
  const { invitation } = useNewProps()
  const { team_profile_name } = invitation
  return (
    <SheetPageBody>
      <SheetPageTitle icon={Mail}>
        {t("response.new.title", { team_profile_name })}
      </SheetPageTitle>

      <div className="space-y-6">
        <p className="text-sm">
          {t(`response.new.status_description.${invitation.state}`, {
            team_profile_name,
          })}
        </p>

        {(invitation.rejectable || invitation.acceptable) && (
          <Alert>
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>{t("response.new.warning")}</AlertDescription>
          </Alert>
        )}

        <div className="flex gap-3">
          {invitation.acceptable && (
            <Link
              as={Button}
              method="post"
              href="."
              data={{ response: "accept" }}
              className="flex-1"
            >
              <Check className="h-4 w-4" />
              {t("response.new.accept")}
            </Link>
          )}

          {invitation.rejectable && (
            <Link
              as={Button}
              method="post"
              href="."
              data={{ response: "reject" }}
              className="flex-1"
            >
              <X className="h-4 w-4" />
              {t("response.new.reject")}
            </Link>
          )}
        </div>

        <div className="space-y-3 text-sm">
          {invitation.acceptable && (
            <div className="flex gap-3">
              <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-green-600" />
              <div>
                <p className="font-medium">
                  {t("response.new.accept_info.heading")}
                </p>
                <p>{t("response.new.accept_info.description")}</p>
              </div>
            </div>
          )}

          {invitation.rejectable && (
            <div className="flex gap-3">
              <XCircle className="mt-0.5 h-5 w-5 shrink-0 text-red-600" />
              <div>
                <p className="font-medium">
                  {t("response.new.reject_info.heading")}
                </p>
                <p>{t("response.new.reject_info.description")}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </SheetPageBody>
  )
}
